/* eslint-disable react/prop-types */
import { useRef } from "react";
import { toast } from "react-toastify";
import { MAX_SUPPORT_ATTACHMENTS, validateSupportAttachments } from "../../../services/SupportService";

const getFileKey = (file) => `${file.name}-${file.size}-${file.lastModified}`;

export function SupportReplyAttachmentFields({
  attachments = [],
  onChange,
  disabled = false,
  max = MAX_SUPPORT_ATTACHMENTS,
}) {
  const fileInputRef = useRef(null);
  const canAddMore = attachments.length < max;

  const handleChange = (event) => {
    const picked = Array.from(event.target.files || []);
    event.target.value = "";
    if (!picked.length) return;

    const merged = [...attachments, ...picked];
    const error = validateSupportAttachments(merged);
    if (error) {
      toast.error(error);
      return;
    }
    onChange(merged.slice(0, max));
  };

  const removeAt = (index) => {
    onChange(attachments.filter((_, i) => i !== index));
  };

  return (
    <div className="stk-reply-attachments">
      {canAddMore && (
        <button
          type="button"
          className="stk-reply-attachments__add"
          onClick={() => fileInputRef.current?.click()}
          disabled={disabled}
        >
          <i className="fas fa-paperclip" aria-hidden="true" />
          Add files
          <span className="stk-reply-attachments__hint">
            PNG, JPG, WEBP, GIF, PDF · {attachments.length}/{max}
          </span>
        </button>
      )}
      <input
        ref={fileInputRef}
        type="file"
        multiple
        hidden
        accept="image/*,.pdf,application/pdf"
        onChange={handleChange}
        disabled={disabled}
      />
      {attachments.length > 0 && (
        <ul className="stk-reply-attachments__list">
          {attachments.map((file, index) => (
            <li key={getFileKey(file)}>
              <span>{file.type === "application/pdf" ? "📄" : "🖼️"}</span>
              <span className="stk-reply-attachments__name">{file.name}</span>
              <button
                type="button"
                onClick={() => removeAt(index)}
                disabled={disabled}
                aria-label={`Remove ${file.name}`}
              >
                ×
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function SupportMessageAttachments({ attachments = [], getUrl, variant = "user" }) {
  if (!attachments?.length) return null;

  return (
    <ul className={`stk-msg-attachments stk-msg-attachments--${variant}`}>
      {attachments.map((file) => {
        const url = getUrl(file.filename);
        const label = file.originalName || file.filename;
        const isImage = (file.mimeType || "").startsWith("image/");
        return (
          <li key={file.filename || label}>
            <a href={url} target="_blank" rel="noopener noreferrer">
              <i className={`fas fa-${isImage ? "image" : "file-pdf"}`} aria-hidden="true" />
              {label}
            </a>
          </li>
        );
      })}
    </ul>
  );
}
